import './App.css';
import { Route, Routes } from 'react-router-dom';
import CargarComprobante from './pages/cargar_comprobante';
import { Box } from '@mui/material';
import Header from './commons/header';
import Footer from './commons/footer';

function App() {
  return (
    <Box sx={{ flexDirection: 'column', minHeight: '100vh', height: '100%' }}>
      <Header />
      <Box sx={{ flex: 1, height: '100%' }}>
        <Routes>
          <Route path="/cargar_comprobante" element={<CargarComprobante />} />    
        </Routes>
      </Box>
      <Footer />
    </Box>
  );
}

export default App;
